import React, { useEffect, useState } from 'react';
import './gyogik.css';
import { useParams,Link } from "react-router-dom"
import noImage from './no-img.png';


function Gyogik_info() {
  const { variable1, variable2 } = useParams(); // 두 변수를 가져옵니다.
  const [data, setData] = useState([]);
  const [gyogik, setgyogik] = useState([]);
  useEffect(() => {
    const url3 = `/backend/gikwon`;
    fetch(url3)
    .then(response => response.json())
    .then(data => {
      // 서버로부터 받은 데이터 처리
      console.log(data);
      setgyogik(data);
      console.log(Array.isArray(data));
    })
  }, []);

  return (
    <div className="container">
      <div className="page">
         <div className="AppG App-headerG gnb_bsG">
         <header style={{width: "100%"}}>
          <div className="gnb_1">
          <button onClick={() => window.history.back()} class="arrow-button">
  <span class="arrow-icon"></span>
</button>
                <span className="title">{variable2}</span>
                <div className="gnb_1_1">
                    <Link className="gnb_qrG" to="/qr">
                        <div className="gnb_qrG"></div>
                    </Link>
                   {/*   <a className="gnb_notiG" href="/"></a> */}
                </div>
          </div>
        </header>
          <div className="body">
            
          <div>
          {
          gyogik
            .filter(item => item.ORG_NM === variable2)
            .map((filteredItem, index) => (
              <div className="list_info" key={filteredItem.id}>
                <div className="box">
                  
                  <div className="pic">
                  {filteredItem.PHOTO_URL ?  ( 
                  <img style={{ width: '90px', height:'110px' }} src={`data:image/jpeg;base64,${filteredItem.PHOTO_URL}`} onerror='this.src=/common/no-img.png'/>
                   ) : ( 
                   <img style={{ width: '90px', height:'110px' }} src={noImage}/>   
                   )}
				  
				  </div>

                  <div className="txt">
                <span>{filteredItem.USER_NM}</span>
                <a>{filteredItem.ORG_NM}/{filteredItem.USER_CLS}</a>
                <a>{filteredItem.WORK}</a>
                <a>HP : {filteredItem.HAND_PHONE}</a>
                <a>E-MAIL : {filteredItem.EMAIL}</a>
                <a>OFFICE : {filteredItem.HT_TEL}</a>
                </div>
                </div>
                </div>
            ))
        }
        </div>

          </div>
	      </div>
	    </div>
	  </div>
  );
}

export default Gyogik_info;

